// extracted by mini-css-extract-plugin
export default {"container":"Portfolio_container__6NSLd","scale":"Portfolio_scale__DY+QO","fade-in":"Portfolio_fade-in__quUCx"};